import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import type { Chat } from '@trinity/chat';
import type { RootState } from '@/store/store';

const selectAuthor = (user: RootState['user'], group: RootState['group']): Chat.Creator => {
  if (!user && !group) {
    return {
      identifier: null,
      metadata: {},
      brandIndications: [],
      profile: {
        email: '',
        firstName: '',
        lastName: '',
        name: '',
        photoUrl: null,
      },
      isFirstSession: false,
      group: { id: 0 },
    };
  }

  return {
    identifier: user.identifier,
    metadata: user.metadata,
    brandIndications: user.brandIndications,
    profile: {
      email: user.email,
      firstName: user.profile.firstName,
      lastName: user.profile.lastName,
      name: user.profile.name,
      photoUrl: user.profile.photoUrl,
    },
    isFirstSession: user.isFirstSession || false,
    group: { id: group.id },
  };
};

const userSelector = (state: RootState) => state.user;
const groupSelector = (state: RootState) => state.group;

const selector = createSelector([userSelector, groupSelector], (user, group) => {
  return selectAuthor(user, group);
});

export const useBrandInsightsAuthor = () => {
  return useSelector(selector);
};